import Rate from './rate.vue';
export default Rate;



// WEBPACK FOOTER //
// ./src/components/rate/index.js